import { Org } from '@/types';

export type OrgSwitchResolution =
  | { status: 'synced' }
  | { status: 'no-access' }
  | { status: 'sso-blocked'; org: Org }
  | { status: 'switch'; org: Org };

/**
 * Whether the user may be moved to `targetOrgId`, and if so which org that is.
 * Shared so that everything deciding "can we go to this org-scoped URL" agrees
 * — the guard that performs the switch and the callers that only need to know
 * whether a URL is reachable before navigating to it.
 */
export function resolveOrgSwitch(
  orgs: Org[],
  currentOrg: Org | null,
  targetOrgId: string | undefined,
): OrgSwitchResolution {
  if (!targetOrgId || !currentOrg || currentOrg.orgid === targetOrgId) {
    return { status: 'synced' };
  }

  const targetOrg = orgs.find((org) => org.orgid === targetOrgId);
  if (!targetOrg) {
    return { status: 'no-access' };
  }

  // An SSO session is pinned to the org it authenticated against.
  if (currentOrg.sso?.auth0_org_id) {
    return { status: 'sso-blocked', org: targetOrg };
  }

  return { status: 'switch', org: targetOrg };
}
